import React from 'react'

import { Modal, Table, Button } from '_zari/core'

import { EstadosPreFacturacion } from 'constants/index'

import { IdGen } from 'utils'

import * as PreFacturacionService from 'services/preFacturacion.service'

const ListaPreVentasModal = ({ show, handleClose, dispatch, setFieldValue, reiniciarFormularioMontos }) => {
  const [listaPreVentas, setListaPreVentas] = React.useState([])

  React.useEffect(() => {
    PreFacturacionService.obtenerxEstadoAsTabla(EstadosPreFacturacion.ABIERTO).then(({ data }) => {
      setListaPreVentas(data)
    })
  }, [])

  const clickSeleccionar = React.useCallback(
    id => {
      PreFacturacionService.obtenerxIdAsDetallesVenta(id).then(({ data }) => {
        const detalles = data.map(({ _id, ...x }) => {
          return {
            ...x,
            _idFila: IdGen.newId()
          }
        })

        setFieldValue('_idPreFacturacion', id)
        setFieldValue('flagPreVenta', true)

        dispatch({ type: 'fill', payload: detalles })
        reiniciarFormularioMontos()
        handleClose()
      })
    },
    [dispatch, handleClose, setFieldValue, reiniciarFormularioMontos]
  )

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>LISTA PRE VENTAS</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table
          maxRowsShown={15}
          filas={listaPreVentas}
          headRows={[{ label: 'ID' }, { label: 'NOMBRE' }, { label: 'FECHA' }, { label: 'HORA' }, { label: '' }]}
          rowTemplate={row => (
            <Table.Row key={IdGen.newId()}>
              <Table.Cell>{row.identificador || '--'}</Table.Cell>
              <Table.Cell>{row.nombre || '--'}</Table.Cell>
              <Table.Cell>{row.fechaEmision || '--'}</Table.Cell>
              <Table.Cell>{row.horaEmision || '--'}</Table.Cell>
              <Table.Cell>
                <Button onClick={() => clickSeleccionar(row._id)}>Seleccionar</Button>
              </Table.Cell>
            </Table.Row>
          )}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose}>
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(ListaPreVentasModal)
